import { getCampaignInfo, getBrowserResolution, getBrowser } from '../utils';

export class NavigationChangedAdapter {
  buildPayload = (getUserDeviceId, getSessionId) => {
    const campaignInfo = getCampaignInfo();

    const browserInfo = window.navigator;

    const event = {
      userId: getUserDeviceId(),
      sessionId: getSessionId(),
      eventName: 'page_view',
      eventSourceUrl: window.location.href,
      eventData: {
        campaignData: {
          campaignId: campaignInfo.campanha,
          origin: campaignInfo.origemCampanha,
          utmTerm: campaignInfo.utmTerm,
          utmContent: campaignInfo.utmContent,
          gclid: campaignInfo.gclid,
        },
        accessData: {
          browserName: getBrowser(window),
          browserVersion: browserInfo.appVersion,
          browserSize: getBrowserResolution(),
          language: browserInfo.language,
          userAgent: browserInfo.userAgent,
          urlReferrer: document.referrer,
          operatingSystem: browserInfo.platform,
          abTest: {},
        },
      },
    };

    return event;
  };
}

const instance = new NavigationChangedAdapter();
export default instance;
